import React, { useEffect, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FaTimes, FaSpinner } from 'react-icons/fa';
import axios from 'axios';
import '../index.css'; // your .ios-wallet-button styles

function QRCodeModal({ ticket, isOpen, onClose }) {
  const [addingWallet, setAddingWallet] = useState(false);
  const [isSafari, setIsSafari]         = useState(false);
  console.log(ticket);

  // 1) Safari detection
  useEffect(() => {
    const ua = navigator.userAgent;
    const safariOnIOS = /iP(ad|hone|od)/.test(ua) && /Safari/.test(ua) && !/Chrome/.test(ua);
    const safariOnMac = /Macintosh/.test(ua)  && /Safari/.test(ua) && !/Chrome/.test(ua);
    setIsSafari(safariOnIOS || safariOnMac);
  }, []);

  // Prevent background scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [isOpen]);

  // 2) Direct GET → Wallet flow
  const handleAddToWallet = async () => {
    if (!ticket?.ticketID) return;
    setAddingWallet(true);

    try {
      // 1) Request presigned URL from your Lambda GET route
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_AWS_URL}/${process.env.REACT_APP_STAGE}/addToWallet`, 
        {
          params: { 
            ticketID: ticket.ticketID,
            // include phone if your GET handler needs it:
            phone: ticket.phone
          }
        }
      );

      // 2) Extract the URL from the JSON response
      const { url } = resp.data;
      if (!url) {
        throw new Error('No URL returned from API');
      }

      // 3) Navigate to it – Safari will download the .pkpass and open Wallet
      window.location.href = url;

    } catch (err) {
      console.error('Add to Wallet failed:', err);
      alert('Could not add to Apple Wallet. Please try again.');
    } finally {
      setAddingWallet(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      aria-hidden={!isOpen}
      onClick={onClose}
    >
      <div
        className="qr-modal"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <FaTimes
            className="close-icon"
            onClick={onClose}
            aria-label="Close Modal"
          />
        </div>

        <div className="qr-code-wrapper">
          <QRCodeCanvas value={JSON.stringify(ticket)} size={300} />
        </div>

        <div className="ticket-details">
          <p><strong>Venue:</strong> {ticket.bar_name}</p>
          <p><strong>Name:</strong> {ticket.name}</p>
          <p>
            <strong>Valid until:</strong>{' '}
            {new Date(ticket.datetime_invalid).toLocaleString()}
          </p>
        </div>

        <div className="button-group" style={{ marginTop: 20, display: 'flex', gap: 12 }}>
          {/* only show on Safari */}
            <button
              className='ios-wallet-button'
              onClick={handleAddToWallet}
              disabled={addingWallet}
            >
              {addingWallet
                ? <FaSpinner className="spinner" style={{alignSelf: 'center'}} />
                : <><img src="/Add_To_Apple_Wallet.png" style={{ width: 150 }} alt='Add to Apple Wallet'/></>
              }
            </button>

          {/* always show Close */}
          <button
            className="button-primary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default QRCodeModal;